import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/762f22c8ff45d97868c415d8c5c35baa2da1e939dece33733757badf72a59707.png";

export const IBAN_INFO = {
  holder: "M MAXIME BLOT LEFEVRE SAL DE",
  iban: "FR76 3000 4013 2800 0002 0195 904",
  bic: "BNPAFRPPXXX",
  bank: "BNP Paribas",
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
